<div class="partial-header title">
	<div class="wrapper-sutitle">
		<div class="go-back">
			<a href="javascript:void(0)" (click)="goBack()">
				<i class="fa fa-arrow-left"></i>
			</a>
		</div>
		Partial - {{ headerSubtitle }}
	</div>
	<button class="btn btn-sm cv-btn-light cv-btn-white" (click)="reloadList()">
		<i class="fas fa-sync-alt"></i> Update List
	</button>
</div>